import { render, staticRenderFns } from "./DatatableExample.vue?vue&type=template&id=4baac560"
import script from "./DatatableExample.vue?vue&type=script&lang=js"
export * from "./DatatableExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports